<template>
    <div class="donationResult">
        <div class="formHeader">
            <!-- 返回 -->
            <span @click="goBack"></span>
            <!-- 飞鹤logo -->
            <div class="FHlogo"></div>
        </div>
        <div class="result_mask">
            <!-- 结果 申请成功-->
            <div class="result_box" v-show="successShow">
                <h2>申请成功</h2>
                <p>您已成功提交申请信息，我们会在1-5个工作日内进行审核，请您扫码关注下方二维码查看您的审核结果！</p>
                <div class="qcode_box">
                    <img :src="channelQcode" alt="">
                    <p>扫码关注查看审核结果</p>
                </div>
            </div>
            <!-- 结果 审核通过-->
            <div class="result_box" v-show="examineSuccessShow">
                <h2>审核通过</h2>
                <p>感谢您参与<span>亿起战疫 “鹤”护新生</span>孕产妇奶粉领取活动，您已申请成功！系统将根据您的申领地址安排发货，小鹤正在加紧生产，预计2月20日-3月26日陆续发出。<br/>受疫情影响，部分地区将延迟发货或物流时间较长，非常感谢您的支持与理解。</p>
                <div class="qcode_box">
                    <img :src="channelQcode" alt="">
                    <p>扫码关注查看物流</p>
                </div>
            </div>
            <!-- 结果 审核未通过-->
            <div class="result_box" v-show="examineFailShow">
                <h2>审核未通过</h2>
                <p>感谢您参与<span>亿起战疫 “鹤”护新生</span>孕产妇奶粉领取活动，非常抱歉您未申请成功。小鹤额外为新注册用户准备了200积分的注册礼。<br/><a :href="extStarMomHostName+'api/wechat/auth/assets'">点击这里，开启兑换之旅吧~</a></p>
                <div class="again_btn" @click="againWrite">重新申领</div>
            </div>
            <!-- 结果 申请审核中-->
            <div class="result_box" v-show="examineShow">
                <h2>申请审核中</h2>
                <p>您的申请还在审核中请耐心等待，我们会在1-5个工作日内审核完毕，请您扫码关注下方二维码查看您的审核结果！</p>
                <div class="qcode_box">
                    <img :src="channelQcode" alt="">
                    <p>扫码关注查看审核结果</p>
                </div>
            </div>
            <!-- 结果 发货通知-->
            <div class="result_box" v-show="sendShow">
                <h2>订单通知</h2>
                <p>您的申请订单已创建成功，请在<span>【飞鹤星妈会-个人中心我的订单】</span>中进行查看。系统将根据您的申领地址安排发货，小鹤正在加紧生产，预计2月20日-3月20日陆续发出。</p>
                <div class="qcode_box">
                    <img :src="channelQcode" alt="">
                    <p>扫码关注查看订单</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
.donationResult{
    width: 100%;
    min-height: 100%;
    background: url(../../../assets/images/activity/donationActive/rmask2.png) no-repeat center bottom rgba(253, 234, 33, 1);
    background-size:100% auto;
    .formHeader{
        width:100%;
        height:119px;
        background: url(../../../assets/images/activity/donationActive/headbg.png) no-repeat right bottom #feeb2d;
        background-size:100% 100%;
        box-sizing: border-box;
        position: relative;
        span{
            width:12px;
            height:23px;
            background: url(../../../assets/images/activity/donationActive/form_arr_l.png) no-repeat left center;
            background-size: 100% 100%;
            display: block;
            margin-bottom: 25px;
            position: absolute;
            top: 13px;
            left: 20px;
        }
        .FHlogo{
            width:124px;
            height:25px;
            background: url(../../../assets/images/activity/donationActive/form_logos.png) no-repeat center center;
            background-size: 100% auto;
            position: absolute;
            top: 56px;
            left: 40px;
        }
    }
    .result_mask{
        background: url(../../../assets/images/activity/donationActive/rmask1.png) no-repeat left top;
        background-size:100% auto;
        padding-bottom:50px;
    }
    .result_box{
        height: 431px;
        background:rgba(255,255,255,1);
        border-radius:30px;
        margin: 0 20px;
        padding: 30px 22px 0;
        position: relative;
        h2{
            font-size:20px;
            font-weight:bold;
            color:rgba(5,67,152,1);
            line-height:30px;
            text-align: center;
        }
        p{
            margin-top: 20px;
            font-size:14px;
            color:rgba(110,53,23,1);
            line-height:30px;
            font-weight:400;
            a{
                color: rgba(5, 67, 152, 1);
                text-decoration: underline;
            }
            span{
                font-weight:bold;
            }
        }
        .again_btn{
            height:51px;
            background:linear-gradient(-90deg,rgba(32,61,171,1),rgba(39,76,213,1));
            border-radius:10px;
            position: absolute;
            left: 24px;
            right: 24px;
            bottom: 52px;
            margin: auto;
            font-size:20px;
            font-weight:bold;
            color:rgba(255,255,255,1);
            line-height:51px;
            text-align: center;
            a{
                display: block;
            }
        }
        .qcode_box{
            width: 100%;
            margin-top: 19px;
            text-align: center;
            img{
                width: 122px;
            }
            p{
                font-size:14px;
                font-weight:400;
                color:rgba(110,53,23,1);
                line-height:30px;
                margin: 0;
            }
        }
    }
}
</style>


<script>
import store from '@/store'
export default {
    name: "donationResult",
    props:{
        resultCode:{
            type: String
        },
        channelName:{
            type: String,
            default: ''
        },
        pageSource:{
            type: String,
            default: null
        }
    },
    data() {
        return {
            extStarMomHostName:this.$http.extStarMomHostName,
            successShow:false,//申请成功
            examineSuccessShow:false,//审核通过
            examineFailShow:false,//审核未通过
            examineShow:false,//审核中
            sendShow:false,//发货通知
            channelQcode:require("../../../assets/images/activity/donationActive/qcode.jpg")
        };
    },
    watch:{
        resultCode(){
            this.setUserCode();
            this.channelQcode = (this.channelName && this.channelName!="")? "https://image-mom.feihe.com/channelQcode/"+this.pageSource+".jpg":require("../../../assets/images/activity/donationActive/qcode.jpg");
        }
    },
    mounted() {
    },
    methods: {
        againWrite(){
            this.$emit("userAgainWrite");
        },
        setUserCode(){
            this.examineShow = false;
            this.examineSuccessShow = false;
            this.examineFailShow = false;
            this.successShow = false;
            this.sendShow = false;
            /**
             * code值：
             * 200 可以填写用户信息
             * 201 已提交（审核中）
             * 202 审核通过
             * 203 审核驳回（审核未通过）
             * 204 订单创建了
             */
            switch(this.resultCode){
                case "201":this.examineShow = true;
                    break;
                case "202":this.examineSuccessShow = true;
                    break;
                case "203":this.examineFailShow = true;
                    break;
                case "true":this.successShow = true;
                    break;
                case "204":this.sendShow = true;
                    break;
                // default: this.successShow = true;
            }
        },
        goBack(){
            this.$emit("goBack");
        }
    },
  
};
</script>
